import { subscribe } from 'valtio'
import { getHumanParticipants } from '../webRTCRoom'
import {
  floorInitState,
  isFloorValid,
  switchToSolo,
} from '../../firebase/hooks/useFloor'
import { trayInitState } from '../../firebase/hooks/useTray'
import { getRole } from '../../global/roomInfo/roomInfo'
import {
  isPanelInitialized,
  panelInitState,
} from '../../firebase/hooks/usePanel'

let hasCheckHappened = false

const check = () => {
  // only check once at joining the room
  if (hasCheckHappened) return

  const isTrayReady =
    trayInitState.trayCardsInitialized &&
    trayInitState.lastActiveMediaCardInitialized

  const { isFloorReady } = floorInitState

  const isPanelReady = isPanelInitialized()

  // wait for firebase to be fully initialized
  if (!isFloorReady || !isTrayReady || !isPanelReady) return

  const participants = getHumanParticipants()
  const participantsIds = participants.map((p) => p.id)
  const localParticipant = participants.find((p) => p.isLocal)

  if (!localParticipant) return

  if (!isFloorValid(participantsIds)) {
    switchToSolo(localParticipant.id, 'camera')
  }

  hasCheckHappened = true
}

const init = () => {
  if (getRole() !== 'producer') return

  subscribe(floorInitState, check)
  subscribe(trayInitState, check)
  subscribe(panelInitState, check)

  check()
}

export { init }
